import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { turniejeOrg } from '../../hooks/useTenant';

export const ConsentSection = ({
  regulationsAgreed,
  setRegulationsAgreed,
  gdprAgreed,
  setGdprAgreed,
  marketingAgreed,
  setMarketingAgreed,
  tLegalName,
}: any) => (
  <>
    <FormControlLabel
      sx={{ marginBottom: 1, textAlign: 'justify' }}
      control={
        <Checkbox size="small" checked={regulationsAgreed} onChange={(e) => setRegulationsAgreed(e.target.checked)} required />
      }
      label={`Wyrażam zgodę na przetwarzanie moich danych osobowych przez organizatora ${tLegalName} w celu rejestracji i udziału w wydarzeniu. Wiem, że mam prawo do wycofania zgody w dowolnym momencie.`}
    />
    <FormControlLabel
      sx={{ marginBottom: 1, textAlign: 'justify' }}
      control={<Checkbox size="small" checked={gdprAgreed} onChange={(e) => setGdprAgreed(e.target.checked)} required />}
      label={`Wyrażam zgodę na przetwarzanie moich danych osobowych przez ${turniejeOrg.tLegalName} w celu zapewnienia obsługi technicznej platformy oraz realizacji mojej rejestracji do wydarzenia. Wiem, że mam prawo do wycofania zgody w dowolnym momencie.`}
    />
    <FormControlLabel
      sx={{ marginBottom: 1, textAlign: 'justify' }}
      control={<Checkbox size="small" checked={marketingAgreed} onChange={(e) => setMarketingAgreed(e.target.checked)} />}
      label={`Wyrażam zgodę na otrzymywanie informacji o przyszłych wydarzeniach, usługach i ofertach Turnieje.org.`}
    />
  </>
);
